// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-box-container {
    padding: 14px;

    .base-box {
        width: auto;
        padding: 27px 26px;  
        border-radius: 8px;
        background-color: #ffffff;
        border: 1px solid red;
        display: flex;
        align-items: center;
    }
}
.component-container {
    /* margin: 7px 16px; */
    /* margin: 7px 7px; */
    /* padding: 20px 20px;   */
    padding: 14px 14px;  
    border-radius: 8px;
    background-color: #ffffff;
    display: flex;
    gap: 7px;
    align-items: center;
    &:first-child {
        /* margin-top: 7px;
        margin-left: 7px; */
    }
    &.start {
        height: 100%;
        align-items: start;
    }
    
}
.component-container ~ .component-container {
    /* margin-top: 7px; */
}

.component-container-pdf {
    /* margin: 7px 16px; */
    /* margin: 7px 7px; */
    /* padding: 20px 20px;   */
    width: calc(21cm) ;
    height: calc(29.7cm - 18px);
    margin: auto;
    padding: 7px 7px;  
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 7px;
    
    &:first-child {
        /* margin-top: 7px;
        margin-left: 7px; */
    }
    &.start {
        height: 100%;
        align-items: start;
    }

    .pdf_info {
        width: 100%;
        font-size: 12px;
        align-items: center;
        div {
            font-size: 12px;
            align-items: center;
        }
    }

    .pdf_info_highlight {
        font-size: 14px;
        div {
            font-size: 14px;
            letter-spacing: 0.4px;
        }
    }

    .component-inner-container-pdf {
        border: 1px solid var(--color-gray10);
        border-radius: 8px;
        width: 100%;
        height: 100%;
        padding: 14px;

    }
}


.component-box {
    padding: 2px;
}
.component-container-full-modal {
    .ant-modal {
        max-width: 100%;
        top: 0;
        padding-bottom: 0;
        margin: 0;
    }
    .ant-modal-content {
        display: flex;
        flex-direction: column;
        height: calc(100vh);
        width: 100vw;
    }
    .ant-modal-body {
        flex: 1 1;
    }
}
.summary-label-left {
    color: var(--color-gray02);
    line-height: 24px;
    font-size: 1.3rem;
  }
.summary-value-left {
    line-height: 24px;
    font-size: 1.8rem;
    font-weight: bold;
}
.summary-up-value-left {
    color: var(--color-gray11);
    line-height: 24px;
    font-size: 1.3rem;
}
.summary-down-value-left {
    color: var(--color-gray11);
    line-height: 24px;
    font-size: 1.3rem;
}
.summary-label-center {
    color: var(--color-gray02);
    line-height: 24px;
    font-size: 1.3rem;
    text-align: center;
}
.summary-value-center {
    line-height: 24px;
    font-size: 1.8rem;
    font-weight: bold;
    text-align: center;
}
.summary-up-value-center {
    color: var(--color-gray11);
    line-height: 24px;
    font-size: 1.3rem;
}
.summary-down-value-center {
    color: var(--color-gray11);
    line-height: 24px;
    font-size: 1.3rem;
}
.order-item {
    border: 1px solid var(--color-gray08);
    width: 130px;
    height: 85px;
    color: #000;
}
.order-item-label {
    padding: 10px;
    border-bottom: 1px solid var(--color-gray08);
    background-color: var(--color-gray08);
    font-size: 1.2rem;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    height: 45px;
    line-height: 1.2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
.order-item-value {
    padding: 10px;
    line-height: 1.2;
    font-size: 1.2rem;
    font-size: 12px; 
    font-weight: 400;
    text-align: center;
}


.class-item-wrap {
    display: flex;
    flex-direction:column;
    /* width: 177px; */
    margin-top: 7px;

    .class-item-header{
        display: flex;
        justify-content: space-between;
        position: relative;
        top: 26px;
        z-index: 1;
        height: 24px;
        width: 150px;
    }

    .class-item {
        border: 1px solid var(--color-gray10);
        /* width: 157px; */
        /* width: 177px;
        height: 180px; */
        text-align: center;
        display: table-cell;
        vertical-align: middle;
    
        .class-item-pin {
            position: absolute;
            margin: -10px 0px -20px 0px;
            z-index: 1;
        }
        .class-item-new {
            position: absolute;
            margin: -10px 0px -20px 0px;
            z-index: 1;
        }
    }

    .class-item-title {
        line-height: 24px;
        font-size: 1.4rem;
        overflow: hidden;
    }
    .class2-item-title {
        line-height: 24px;
        font-size: 1.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    
    .class-item-content {
        line-height: 24px;
        font-size: 1rem;
        color: var(--color-gray11);
    }
}



.goods-item {
    padding: 10px;
    border: 1px solid var(--color-gray10);
    text-align: center;
    display: table-cell;
    vertical-align: middle;
}
.seq-item {
    /* border: 1px solid var(--color-gray10); */
    width: 40px;
    height: 30px;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    
}
.seq-item input{
    height: 100%;
    text-align: center;;
    
}
.seq-item-label {
    line-height: 30px;
    font-size: 1.4rem;
}

.schoolWrap {
    justify-content:space-between;
    gap: 7px;
    padding: 7px;
}
.schoolWrap .main-content { 
    flex: 0 1 100%;
    width: calc(100% - 50px);
}
.quick-menu-open {
    position: fixed;
    top: 20%;
    right: 0;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    box-shadow: 0 .1rem 1rem .25rem rgba(0,0,0,.05)!important;
    background-color: white;
}
.quick-menu-open-item {
    padding: 1rem 1rem;
    cursor: pointer;
    text-align: center;
    line-height: 1.4;
    height: 40px;
}
.quick-menu-open-item:hover {
    color: var(--color-blue01);
}
.quick-menu {
    /* position: fixed; */
    height: 100%;
    position: static;
    top: 20%;
    right: 0;
    .quick-menu-inner-wrap {
        border-radius: 14px;
        box-shadow: 0 .1rem 1rem .25rem rgba(0,0,0,.05)!important;
        background-color: white;
    }
}
.quick-menu-item {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid var(--color-gray10);
    cursor: pointer;
    text-align: center;
    line-height: 1.4;
    height: 60px;
}
.quick-menu-item:first-child {
    height: 40px;
}
.quick-menu-item:nth-of-type(8) {
    display: flex;
    align-items: center;
}
.quick-menu-item:last-child {
    border:none;
}
.quick-menu-item:hover {
    color: var(--color-blue01);
}
.break-down-table-wrap {
    border: 1px solid black;
    width: 180px;
    text-align: center;
}
.break-down-table-wrap > div:first-child {
    background-color: var(--color-gray08);
    border-bottom: 1px solid black;
    height: 50px;
}
.break-down-table-wrap > div:last-child {
    border-bottom: none;
}

.break-down-table-wrap2 {
    border: 1px solid black;
    width: 180px;
    text-align: center;
}
.break-down-table-wrap2 > div:first-child {
    background-color: var(--color-gray08);
    border-bottom: 1px solid black;
    height: 70px;
}
.break-down-table-wrap2 > div:last-child {
    border-bottom: none;
}

/* 수정 필요 */
.break-down-table-item{
    height: 23px;
    border-bottom: 1px solid black;
    &.type-1{
        background-color: var(--color-red05);
    }
    &.type-2{
        background-color: var(--color-gray10);
    }
    &.type-3{
        background-color: var(--color-yellow01);
    }
}

/* .ant-tabs-top >.ant-tabs-nav::before, */
/* round tab */
.ant-tabs.ant-tabs-top.round-tab {
    .ant-tabs-nav {
        padding-left: 0px;
        .ant-tabs-ink-bar {
            height: 0px;
        }
        &::before {
            content: '';
            border-bottom: none;
        }
        .ant-tabs-nav-wrap {
            justify-content: center;
            .ant-tabs-nav-list {
                border-radius: 99px;
                background-color: #F0F0F0;
                .ant-tabs-tab {
                    padding: 10px;
                    min-width: 100px;
                    display: flex;
                    justify-content:center;
                    text-align: center;
                    border: none;
                    border-radius: 99px;
                    background-color: #F0F0F0;
                    background-color: FFF;
                    > .ant-tabs-tab-btn {
                        color: #969696 !important
                    }
                    +.ant-tabs-tab {
                        margin: 0 0 0 0;;
                    }
                    &.ant-tabs-tab-active {
                        border-radius: 99px;
                        min-width: 100px;
                        border: 1px solid var(--color-gray03);
                        color: var(--color-gray03) !important;
                        background-color: #fff;
                        > .ant-tabs-tab-btn {
                            color: var(--color-gray03) !important
                        }
                    }
                    
                }
            }
            
        }
    }
}

.ant-segmented.ant-segmented-lg {
    .ant-segmented-item {
        min-height: 40px;
        line-height: 40px;
        padding: 0 11px;
        font-size: 16px;

        &.ant-segmented-item-selected {
            border: 1px solid #282B3E;
            box-shadow: none;
            &.ant-segmented-item-disabled {
                border: 1px solid #282B3E80;
            }
        }
    }
}

.show-toggle{
    display: none;
}
.show-toggle.display {
    display: contents;
}

.book-category-tree {
    width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;;IAEb;QACI,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB,yBAAyB;QACzB,qBAAqB;QACrB,aAAa;QACb,mBAAmB;IACvB;AACJ;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB;QACI;2BACmB;IACvB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;;AAEJ;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;;IAER;QACI;2BACmB;IACvB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB;YACI,eAAe;YACf,mBAAmB;QACvB;IACJ;;IAEA;QACI,eAAe;QACf;YACI,eAAe;YACf,qBAAqB;QACzB;IACJ;;IAEA;QACI,qCAAqC;QACrC,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;;IAEjB;AACJ;;;AAGA;IACI,YAAY;AAChB;AACA;IACI;QACI,eAAe;QACf,MAAM;QACN,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,SAAO;IACX;AACJ;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;EACnB;AACF;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,4CAA4C;IAC5C,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AACF;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;;IAEf;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,qCAAqC;QACrC,kBAAkB;QAClB;wBACgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;;QAEtB;YACI,kBAAkB;YAClB,2BAA2B;YAC3B,UAAU;QACd;QACA;YACI,kBAAkB;YAClB,2BAA2B;YAC3B,UAAU;QACd;IACJ;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,0BAA0B;IAC9B;AACJ;;;;AAIA;IACI,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;;AAE1B;AACA;IACI,YAAY;IACZ,kBAAkB;;AAEtB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,QAAQ;IACR,YAAY;AAChB;AACA;IACI,cAAc;IACd,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,QAAQ;IACR,QAAQ;IACR,4BAA4B;IAC5B,+BAA+B;IAC/B,yDAAyD;IACzD,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,QAAQ;IACR;QACI,mBAAmB;QACnB,yDAAyD;QACzD,uBAAuB;IAC3B;AACJ;AACA;IACI,oBAAoB;IACpB,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,8BAA8B;IAC9B;QACI,oCAAoC;IACxC;IACA;QACI,qCAAqC;IACzC;IACA;QACI,uCAAuC;IAC3C;AACJ;;AAEA,0CAA0C;AAC1C,cAAc;AACd;IACI;QACI,iBAAiB;QACjB;YACI,WAAW;QACf;QACA;YACI,WAAW;YACX,mBAAmB;QACvB;QACA;YACI,uBAAuB;YACvB;gBACI,mBAAmB;gBACnB,yBAAyB;gBACzB;oBACI,aAAa;oBACb,gBAAgB;oBAChB,aAAa;oBACb,sBAAsB;oBACtB,kBAAkB;oBAClB,YAAY;oBACZ,mBAAmB;oBACnB,yBAAyB;oBACzB,qBAAqB;oBACrB;wBACI;oBACJ;oBACA;wBACI,eAAe;oBACnB;oBACA;wBACI,mBAAmB;wBACnB,gBAAgB;wBAChB,qCAAqC;wBACrC,qCAAqC;wBACrC,sBAAsB;wBACtB;4BACI;wBACJ;oBACJ;;gBAEJ;YACJ;;QAEJ;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf,eAAe;;QAEf;YACI,yBAAyB;YACzB,gBAAgB;YAChB;gBACI,2BAA2B;YAC/B;QACJ;IACJ;AACJ;;AAEA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".base-box-container {\r\n    padding: 14px;\r\n\r\n    .base-box {\r\n        width: auto;\r\n        padding: 27px 26px;  \r\n        border-radius: 8px;\r\n        background-color: #ffffff;\r\n        border: 1px solid red;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n}\r\n.component-container {\r\n    /* margin: 7px 16px; */\r\n    /* margin: 7px 7px; */\r\n    /* padding: 20px 20px;   */\r\n    padding: 14px 14px;  \r\n    border-radius: 8px;\r\n    background-color: #ffffff;\r\n    display: flex;\r\n    gap: 7px;\r\n    align-items: center;\r\n    &:first-child {\r\n        /* margin-top: 7px;\r\n        margin-left: 7px; */\r\n    }\r\n    &.start {\r\n        height: 100%;\r\n        align-items: start;\r\n    }\r\n    \r\n}\r\n.component-container ~ .component-container {\r\n    /* margin-top: 7px; */\r\n}\r\n\r\n.component-container-pdf {\r\n    /* margin: 7px 16px; */\r\n    /* margin: 7px 7px; */\r\n    /* padding: 20px 20px;   */\r\n    width: calc(21cm) ;\r\n    height: calc(29.7cm - 18px);\r\n    margin: auto;\r\n    padding: 7px 7px;  \r\n    background-color: #ffffff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    gap: 7px;\r\n    \r\n    &:first-child {\r\n        /* margin-top: 7px;\r\n        margin-left: 7px; */\r\n    }\r\n    &.start {\r\n        height: 100%;\r\n        align-items: start;\r\n    }\r\n\r\n    .pdf_info {\r\n        width: 100%;\r\n        font-size: 12px;\r\n        align-items: center;\r\n        div {\r\n            font-size: 12px;\r\n            align-items: center;\r\n        }\r\n    }\r\n\r\n    .pdf_info_highlight {\r\n        font-size: 14px;\r\n        div {\r\n            font-size: 14px;\r\n            letter-spacing: 0.4px;\r\n        }\r\n    }\r\n\r\n    .component-inner-container-pdf {\r\n        border: 1px solid var(--color-gray10);\r\n        border-radius: 8px;\r\n        width: 100%;\r\n        height: 100%;\r\n        padding: 14px;\r\n\r\n    }\r\n}\r\n\r\n\r\n.component-box {\r\n    padding: 2px;\r\n}\r\n.component-container-full-modal {\r\n    .ant-modal {\r\n        max-width: 100%;\r\n        top: 0;\r\n        padding-bottom: 0;\r\n        margin: 0;\r\n    }\r\n    .ant-modal-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        height: calc(100vh);\r\n        width: 100vw;\r\n    }\r\n    .ant-modal-body {\r\n        flex: 1;\r\n    }\r\n}\r\n.summary-label-left {\r\n    color: var(--color-gray02);\r\n    line-height: 24px;\r\n    font-size: 1.3rem;\r\n  }\r\n.summary-value-left {\r\n    line-height: 24px;\r\n    font-size: 1.8rem;\r\n    font-weight: bold;\r\n}\r\n.summary-up-value-left {\r\n    color: var(--color-gray11);\r\n    line-height: 24px;\r\n    font-size: 1.3rem;\r\n}\r\n.summary-down-value-left {\r\n    color: var(--color-gray11);\r\n    line-height: 24px;\r\n    font-size: 1.3rem;\r\n}\r\n.summary-label-center {\r\n    color: var(--color-gray02);\r\n    line-height: 24px;\r\n    font-size: 1.3rem;\r\n    text-align: center;\r\n}\r\n.summary-value-center {\r\n    line-height: 24px;\r\n    font-size: 1.8rem;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}\r\n.summary-up-value-center {\r\n    color: var(--color-gray11);\r\n    line-height: 24px;\r\n    font-size: 1.3rem;\r\n}\r\n.summary-down-value-center {\r\n    color: var(--color-gray11);\r\n    line-height: 24px;\r\n    font-size: 1.3rem;\r\n}\r\n.order-item {\r\n    border: 1px solid var(--color-gray08);\r\n    width: 130px;\r\n    height: 85px;\r\n    color: #000;\r\n}\r\n.order-item-label {\r\n    padding: 10px;\r\n    border-bottom: 1px solid var(--color-gray08);\r\n    background-color: var(--color-gray08);\r\n    font-size: 1.2rem;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    height: 45px;\r\n    line-height: 1.2;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n.order-item-value {\r\n    padding: 10px;\r\n    line-height: 1.2;\r\n    font-size: 1.2rem;\r\n    font-size: 12px; \r\n    font-weight: 400;\r\n    text-align: center;\r\n}\r\n\r\n\r\n.class-item-wrap {\r\n    display: flex;\r\n    flex-direction:column;\r\n    /* width: 177px; */\r\n    margin-top: 7px;\r\n\r\n    .class-item-header{\r\n        display: flex;\r\n        justify-content: space-between;\r\n        position: relative;\r\n        top: 26px;\r\n        z-index: 1;\r\n        height: 24px;\r\n        width: 150px;\r\n    }\r\n\r\n    .class-item {\r\n        border: 1px solid var(--color-gray10);\r\n        /* width: 157px; */\r\n        /* width: 177px;\r\n        height: 180px; */\r\n        text-align: center;\r\n        display: table-cell;\r\n        vertical-align: middle;\r\n    \r\n        .class-item-pin {\r\n            position: absolute;\r\n            margin: -10px 0px -20px 0px;\r\n            z-index: 1;\r\n        }\r\n        .class-item-new {\r\n            position: absolute;\r\n            margin: -10px 0px -20px 0px;\r\n            z-index: 1;\r\n        }\r\n    }\r\n\r\n    .class-item-title {\r\n        line-height: 24px;\r\n        font-size: 1.4rem;\r\n        overflow: hidden;\r\n    }\r\n    .class2-item-title {\r\n        line-height: 24px;\r\n        font-size: 1.4rem;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n    \r\n    .class-item-content {\r\n        line-height: 24px;\r\n        font-size: 1rem;\r\n        color: var(--color-gray11);\r\n    }\r\n}\r\n\r\n\r\n\r\n.goods-item {\r\n    padding: 10px;\r\n    border: 1px solid var(--color-gray10);\r\n    text-align: center;\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n}\r\n.seq-item {\r\n    /* border: 1px solid var(--color-gray10); */\r\n    width: 40px;\r\n    height: 30px;\r\n    text-align: center;\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n    \r\n}\r\n.seq-item input{\r\n    height: 100%;\r\n    text-align: center;;\r\n    \r\n}\r\n.seq-item-label {\r\n    line-height: 30px;\r\n    font-size: 1.4rem;\r\n}\r\n\r\n.schoolWrap {\r\n    justify-content:space-between;\r\n    gap: 7px;\r\n    padding: 7px;\r\n}\r\n.schoolWrap .main-content { \r\n    flex: 0 1 100%;\r\n    width: calc(100% - 50px);\r\n}\r\n.quick-menu-open {\r\n    position: fixed;\r\n    top: 20%;\r\n    right: 0;\r\n    border-top-left-radius: 10px;\r\n    border-bottom-left-radius: 10px;\r\n    box-shadow: 0 .1rem 1rem .25rem rgba(0,0,0,.05)!important;\r\n    background-color: white;\r\n}\r\n.quick-menu-open-item {\r\n    padding: 1rem 1rem;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    line-height: 1.4;\r\n    height: 40px;\r\n}\r\n.quick-menu-open-item:hover {\r\n    color: var(--color-blue01);\r\n}\r\n.quick-menu {\r\n    /* position: fixed; */\r\n    height: 100%;\r\n    position: static;\r\n    top: 20%;\r\n    right: 0;\r\n    .quick-menu-inner-wrap {\r\n        border-radius: 14px;\r\n        box-shadow: 0 .1rem 1rem .25rem rgba(0,0,0,.05)!important;\r\n        background-color: white;\r\n    }\r\n}\r\n.quick-menu-item {\r\n    padding: 1rem 1.5rem;\r\n    border-bottom: 1px solid var(--color-gray10);\r\n    cursor: pointer;\r\n    text-align: center;\r\n    line-height: 1.4;\r\n    height: 60px;\r\n}\r\n.quick-menu-item:first-child {\r\n    height: 40px;\r\n}\r\n.quick-menu-item:nth-of-type(8) {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.quick-menu-item:last-child {\r\n    border:none;\r\n}\r\n.quick-menu-item:hover {\r\n    color: var(--color-blue01);\r\n}\r\n.break-down-table-wrap {\r\n    border: 1px solid black;\r\n    width: 180px;\r\n    text-align: center;\r\n}\r\n.break-down-table-wrap > div:first-child {\r\n    background-color: var(--color-gray08);\r\n    border-bottom: 1px solid black;\r\n    height: 50px;\r\n}\r\n.break-down-table-wrap > div:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.break-down-table-wrap2 {\r\n    border: 1px solid black;\r\n    width: 180px;\r\n    text-align: center;\r\n}\r\n.break-down-table-wrap2 > div:first-child {\r\n    background-color: var(--color-gray08);\r\n    border-bottom: 1px solid black;\r\n    height: 70px;\r\n}\r\n.break-down-table-wrap2 > div:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n/* 수정 필요 */\r\n.break-down-table-item{\r\n    height: 23px;\r\n    border-bottom: 1px solid black;\r\n    &.type-1{\r\n        background-color: var(--color-red05);\r\n    }\r\n    &.type-2{\r\n        background-color: var(--color-gray10);\r\n    }\r\n    &.type-3{\r\n        background-color: var(--color-yellow01);\r\n    }\r\n}\r\n\r\n/* .ant-tabs-top >.ant-tabs-nav::before, */\r\n/* round tab */\r\n.ant-tabs.ant-tabs-top.round-tab {\r\n    .ant-tabs-nav {\r\n        padding-left: 0px;\r\n        .ant-tabs-ink-bar {\r\n            height: 0px;\r\n        }\r\n        &::before {\r\n            content: '';\r\n            border-bottom: none;\r\n        }\r\n        .ant-tabs-nav-wrap {\r\n            justify-content: center;\r\n            .ant-tabs-nav-list {\r\n                border-radius: 99px;\r\n                background-color: #F0F0F0;\r\n                .ant-tabs-tab {\r\n                    padding: 10px;\r\n                    min-width: 100px;\r\n                    display: flex;\r\n                    justify-content:center;\r\n                    text-align: center;\r\n                    border: none;\r\n                    border-radius: 99px;\r\n                    background-color: #F0F0F0;\r\n                    background-color: FFF;\r\n                    > .ant-tabs-tab-btn {\r\n                        color: #969696 !important\r\n                    }\r\n                    +.ant-tabs-tab {\r\n                        margin: 0 0 0 0;;\r\n                    }\r\n                    &.ant-tabs-tab-active {\r\n                        border-radius: 99px;\r\n                        min-width: 100px;\r\n                        border: 1px solid var(--color-gray03);\r\n                        color: var(--color-gray03) !important;\r\n                        background-color: #fff;\r\n                        > .ant-tabs-tab-btn {\r\n                            color: var(--color-gray03) !important\r\n                        }\r\n                    }\r\n                    \r\n                }\r\n            }\r\n            \r\n        }\r\n    }\r\n}\r\n\r\n.ant-segmented.ant-segmented-lg {\r\n    .ant-segmented-item {\r\n        min-height: 40px;\r\n        line-height: 40px;\r\n        padding: 0 11px;\r\n        font-size: 16px;\r\n\r\n        &.ant-segmented-item-selected {\r\n            border: 1px solid #282B3E;\r\n            box-shadow: none;\r\n            &.ant-segmented-item-disabled {\r\n                border: 1px solid #282B3E80;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.show-toggle{\r\n    display: none;\r\n}\r\n.show-toggle.display {\r\n    display: contents;\r\n}\r\n\r\n.book-category-tree {\r\n    width: 200px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
